/* Media placeholders — swap these URLs when real HSK footage/stills are available. */
export const MEDIA = {
  heroStill:
    "https://images.unsplash.com/photo-1618329027137-a520b57c6606?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  verticalReel:
    "https://static.prod-images.emergentagent.com/jobs/b9519764-461e-43dd-a8b4-8440d044a9f3/images/79c27fb8b063c395e95dfb0475871a10ec3c20710533218b42a0a70aab6e1791.jpeg",
  micDark:
    "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  studioDesk:
    "https://images.unsplash.com/photo-1612534859320-79465795d8dc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  motionAbstract:
    "https://images.unsplash.com/photo-1759410123400-bd74ca83950b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  motionAbstractAlt:
    "https://images.unsplash.com/photo-1767727239273-5ed97a1986b4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  filmSet:
    "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  soundStage:
    "https://images.unsplash.com/photo-1612544409025-e1f6a56c1152?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  crewBw:
    "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  waferBar:
    "https://static.prod-images.emergentagent.com/jobs/b9519764-461e-43dd-a8b4-8440d044a9f3/images/29f4e13d5edacce6034cd39bb248624315b504200b618678ecc1b717cab4927b.jpeg",
  aiExperiment:
    "https://static.prod-images.emergentagent.com/jobs/b9519764-461e-43dd-a8b4-8440d044a9f3/images/e8f62b7830518a806581dda43ebc403cbf8f91df909a7bef6f96ad39b38a89fe.jpeg",
};

/* SHOWREEL — drop HSK's real cut in here and the player goes live instantly.
   src stays null until genuine footage exists; the section renders an honest,
   designed title card rather than an empty box. */
export const SHOWREEL = {
  youtubeId: "rYFySABN-TU",
  link: "https://www.youtube.com/watch?v=rYFySABN-TU",
  label: "FEATURED EDIT",
  heading: "SELECTED MOTION / EDITING",
};

export const NAV = [
  { label: "REEL", href: "#reel" },
  { label: "WORK", href: "#work" },
  { label: "GRAPHIC DESIGN", href: "#posters" },
  { label: "SERVICES", href: "#services" },
  { label: "ABOUT", href: "#about" },
  { label: "CONTACT", href: "#contact" },
];

export const WHY_HIRE = [
  {
    num: "01",
    title: "ATTENTION",
    line: "Every cut has a purpose.",
    body:
      "The first second decides whether the rest gets watched. Hooks, punch-ins, captions and sound are placed to hold someone who was about to scroll.",
  },
  {
    num: "02",
    title: "CRAFT",
    line: "Editing, motion, sound and story working together.",
    body:
      "Pacing, graphics, colour and audio are the same decision, not four separate passes. That's what makes a brand look expensive and a creator look consistent.",
  },
  {
    num: "03",
    title: "SPEED",
    line: "Turnaround depends on the project. The workflow doesn't have to be slow.",
    body:
      "The pipeline is built for efficient iteration — more versions explored, less time spent waiting between stages.",
  },
];

/* Stills: uploaded project artwork where supplied, otherwise the video's own frame.
   youtubeId powers the muted hover preview; link is the public destination. */
const yt = (id) => `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

/* Ordered for first impression: short-form -> motion -> brand -> spec -> social -> event -> gaming. */
export const PROJECTS = [
  {
    id: "abhishek-banerjee",
    index: "01",
    name: "ABHISHEK BANERJEE",
    kicker: "PODCAST -> SHORT-FORM",
    badge: "SELECTED EDIT",
    category: "Short-Form / Social",
    type: "Podcast / Short-Form Social",
    role: "Video Editor",
    format: "9:16 - Reels / Shorts",
    tools: ["Premiere Pro"],
    year: "\u2014",
    treatment: "v916",
    image: yt("4035sR4SjuA"),
    youtubeId: "4035sR4SjuA",
    link: "https://youtube.com/shorts/4035sR4SjuA?si=tZbMn99Ff8q8X1W9",
    summary:
      "Short-form podcast editing built around concise pacing, clean visual emphasis and social-first presentation. The edit turns spoken conversation into a compact vertical piece through selective cuts, framing changes, captions and controlled visual rhythm while keeping the speaker and the idea at the centre.",
    notes: [
      "Long-form conversation reduced to a self-contained vertical cut",
      "Selective cuts and framing changes to hold a single idea",
      "Captions and visual emphasis kept readable at a glance",
      "Pacing controlled around the speaker, not over them",
    ],
  },
  {
    id: "mrbeast-podcast",
    index: "02",
    name: "MRBEAST PODCAST",
    kicker: "MOTION-LED SHORT-FORM",
    badge: "SELECTED EDIT",
    category: "Creator / Motion",
    type: "Short-Form / Motion Graphics",
    role: "Video Editor / Motion Designer",
    format: "9:16 - Short-Form Social",
    tools: ["Premiere Pro", "Photoshop"],
    year: "\u2014",
    treatment: "v916",
    image: yt("z3qY6fSWFH8"),
    youtubeId: "z3qY6fSWFH8",
    link: "https://youtube.com/shorts/z3qY6fSWFH8?si=I6exH08wpInTZDPx",
    summary:
      "A motion-led short-form podcast edit combining editorial pacing with animated typography, visual emphasis and supporting motion design. The piece demonstrates how spoken material can be reshaped into a more visually active vertical format without losing the clarity of the original conversation.",
    notes: [
      "Animated typography carrying the spoken line",
      "Motion design used for emphasis, not decoration",
      "Editorial pacing kept legible in a vertical frame",
      "Source material identified as MrBeast Podcast \u2014 no affiliation implied",
    ],
  },
  {
    id: "unikick",
    index: "03",
    name: "UNIKICK \u2014 JERSEY REVEAL",
    kicker: "PRODUCT / REVEAL",
    badge: "SELECTED EDIT",
    category: "Brand / Product",
    type: "Brand / Product / Social Video",
    role: "Video Editor / Motion Designer",
    format: "9:16 - Social Video",
    tools: ["Premiere Pro", "Photoshop"],
    year: "\u2014",
    treatment: "v916",
    image: "/stills/unikick.jpg",
    youtubeId: "M6Xnq3MRfZg",
    link: "https://www.youtube.com/watch?v=M6Xnq3MRfZg",
    summary:
      "A product-led jersey reveal for UNIKICK, reworked as an edit built around anticipation, controlled pacing and brand-focused visual presentation. Timing, transitions and reveal structure introduce the product while keeping the jersey and brand identity as the central visual focus.",
    notes: [
      "Presented as a rework of existing footage, not an originated campaign",
      "Reveal structure built on timing and withheld information",
      "Transitions used to carry attention to the product",
      "Brand identity kept as the visual anchor",
    ],
  },
  {
    id: "kitkat",
    index: "04",
    name: "KITKAT \u2014 SPEC AD",
    kicker: "SPEC / COMMERCIAL",
    badge: "SPEC PROJECT",
    category: "Spec / Commercial",
    type: "Spec Commercial / Product Film",
    role: "Video Editor",
    format: "16:9 - Commercial",
    tools: ["Premiere Pro", "Photoshop"],
    year: "\u2014",
    treatment: "w169",
    image: "/stills/kitkat.jpg",
    youtubeId: "-GPLEQNLnzw",
    link: "https://www.youtube.com/watch?v=-GPLEQNLnzw",
    summary:
      "A speculative KitKat commercial edit focused on product presentation, food imagery, visual detail and commercial pacing. Presented as a brand-film exercise, it uses rhythm, shot selection and product emphasis to demonstrate a polished approach to 16:9 commercial editing.",
    notes: [
      "Spec piece \u2014 not a commissioned or broadcast advertisement",
      "Product and food imagery treated for commercial detail",
      "Rhythm and shot selection built for a 16:9 frame",
      "Polish and finishing as the point of the exercise",
    ],
  },
  {
    id: "divya-raas",
    index: "05",
    name: "DIVYA RAAS \u2014 EVENT BUILDUP",
    kicker: "EVENT / PROMO",
    badge: "SELECTED EDIT",
    category: "Event / Campaign",
    type: "Event / Promotional Social Video",
    role: "Video Editor",
    format: "4:5 - Social Video",
    tools: ["Premiere Pro"],
    year: "\u2014",
    treatment: "r45",
    image: "/stills/divya-raas.jpg",
    objectPosition: "50% 32%",
    youtubeId: "g4LcAYZ4otc",
    link: "https://youtube.com/shorts/g4LcAYZ4otc?si=sBv_rWi8BdcBRHEV",
    summary:
      "An event buildup edit created to generate anticipation around Divya Raas through a compact social-first sequence. Pacing, visual selection, typography and promotional structure build momentum toward the event rather than functioning as conventional coverage.",
    notes: [
      "Promotional buildup, not event coverage",
      "Compact sequence cut for a 4:5 social frame",
      "Typography used to carry event information",
      "Structure built toward a single date",
    ],
  },
  {
    id: "stream-highlights",
    index: "06",
    name: "STREAM HIGHLIGHTS",
    kicker: "GAMING / HIGHLIGHTS",
    badge: "SELECTED EDIT",
    category: "Creator / Entertainment",
    type: "Gaming / Stream Highlights",
    role: "Video Editor",
    format: "16:9 - Gaming / YouTube",
    tools: ["Premiere Pro"],
    year: "\u2014",
    treatment: "w169",
    image: yt("1hRHi6Yr-aU"),
    youtubeId: "1hRHi6Yr-aU",
    link: "https://www.youtube.com/watch?v=1hRHi6Yr-aU",
    summary:
      "A gaming-stream highlight edit built around selecting the strongest moments from longer gameplay footage and shaping them into a tighter entertainment piece. It demonstrates moment selection, pacing, reaction timing and cut density.",
    notes: [
      "Hours of stream footage reduced to a highlight sequence",
      "Moment selection and reaction timing as the core skill",
      "Cut density tuned to keep the pace up",
      "Cut for YouTube in 16:9",
    ],
  },
  {
    id: "landscape-short-form",
    index: "07",
    name: "LANDSCAPE SHORT-FORM",
    kicker: "SELECTED EDIT",
    badge: "SELECTED EDIT",
    category: "Creator / Motion",
    type: "Short-Form Content",
    role: "Video Editor / Motion Designer",
    format: "16:9 - Short-Form",
    tools: ["Premiere Pro"],
    year: "\u2014",
    treatment: "w169",
    image: yt("_7ene5cpcUw"),
    youtubeId: "_7ene5cpcUw",
    link: "https://www.youtube.com/watch?v=_7ene5cpcUw",
    summary:
      "A landscape short-form edit focused on turning spoken content into a concise, visually engaging piece through selective cuts, framing, pacing and supporting graphic treatment. It shows short-form structure working outside the standard vertical format when the source and platform call for a wider frame.",
    notes: [
      "Short-form structure in a wide frame",
      "Selective cuts and framing to keep it tight",
      "Supporting graphic treatment where it helps the point",
      "Cut to the format the source actually suits",
    ],
  },
];

export const SERVICES = [
  {
    id: "short-form",
    tag: "SHORT-FORM",
    title: "SHORT-FORM ISN'T A LONG VIDEO, CUT SHORTER.",
    body:
      "It's attention control. Where the hook lands, when the frame changes, what the caption says while the audio does something else. Reels, Shorts, vertical edits, social campaigns.",
    items: ["Rapid hooks", "Punch-ins", "Captions", "Sound design", "Retention structure"],
  },
  {
    id: "creator-content",
    tag: "CREATOR / ENTERTAINMENT",
    title: "EDITED FOR PEOPLE WHO HAVE SOMETHING TO SAY.",
    body:
      "Podcast cuts, creator uploads and gaming stream highlights. Moment selection, pacing and a visual identity that stays consistent upload after upload.",
    items: ["Podcast", "Creator uploads", "Stream highlights", "Repurposing", "Consistency"],
  },
  {
    id: "brand",
    tag: "BRAND / PRODUCT",
    title: "GOOD FOOTAGE IS ONLY THE STARTING POINT.",
    body:
      "Product reveals, brand social, promos and spec commercials. Reveal structure, timing and product emphasis — then versioned for the formats it needs to live in.",
    items: ["Product reveal", "Brand social", "Promo", "Spec commercial", "Finishing"],
  },
  {
    id: "motion",
    tag: "MOTION & DESIGN",
    title: "MOTION SHOULD EXPLAIN, NOT DECORATE.",
    body:
      "Kinetic typography, lower thirds, animated layouts, callouts, title design and graphic design — used to point at the thing that matters. Complex doesn't have to look complicated.",
    items: ["Kinetic type", "Lower thirds", "Callouts", "Titles", "Graphic design"],
  },
];

export const CREATORS = [
  { name: "RAKUL PREET SINGH", role: "CREATOR CONTENT" },
  { name: "ABHISHEK BANERJEE", role: "CREATOR CONTENT" },
  { name: "VISHAL & SHEYKHAR", role: "CREATOR CONTENT" },
  { name: "KANIKA DHILLON", role: "CREATOR CONTENT" },
];

export const TOOLS = [
  { name: "PREMIERE PRO", use: "EDIT / PACE / SOUND / FINISH" },
  { name: "PHOTOSHOP", use: "DESIGN / COMPOSITE / KEY VISUALS" },
  { name: "CLAUDE", use: "IDEATE / STRUCTURE / ITERATE" },
  { name: "HIGGSFIELD", use: "GENERATE / EXPERIMENT / VISUALISE" },
  { name: "ELEVENLABS", use: "VOICE / NARRATION / AUDIO" },
];

export const PIPELINE = ["BRIEF", "IDEA", "ASSETS", "EDIT", "MOTION", "SOUND", "FINAL"];

export const PROCESS = [
  { num: "01", name: "BRIEF", q: "What are we trying to make?", body: "Objective, audience, platform, and the one thing the viewer must remember." },
  { num: "02", name: "DIRECTION", q: "What should it feel like?", body: "Reference, rhythm, sound direction and the visual language of the cut." },
  { num: "03", name: "EDIT", q: "What keeps people watching?", body: "Assembly, trimming, structure. Everything that doesn't earn its second comes out." },
  { num: "04", name: "POLISH", q: "Motion. Sound. Graphics. Pacing.", body: "Graphics, colour, sound design and the small timing decisions nobody notices but everybody feels." },
  { num: "05", name: "DELIVERY", q: "Ready to publish.", body: "Platform-correct exports, captions and versions. Handed over finished." },
];

export const AI_USES = [
  { k: "IDEATION", v: "Angles, hooks and structure explored before the timeline opens" },
  { k: "EXPLORATION", v: "More creative directions tested in the same window" },
  { k: "VISUAL PROTOTYPING", v: "Concept frames and moving references, fast" },
  { k: "VOICE PROTOTYPING", v: "Scratch narration to test pacing before the real record" },
  { k: "ITERATION", v: "Versions without a queue between them" },
];

export const CONTACT = {
  instagram: "@hskwastaken",
  instagramUrl: "https://instagram.com/hskwastaken",
  location: "MUMBAI, INDIA",
  availability: "WORKING WORLDWIDE",
};
